export const parentCategories = {
  Packages: ["Packages", "Pick 5", "Extreme", "Modern Warfare", "WWII", "Vietnam"],

  Category: [
    "Assault & Battle Rifles",
    "Submachine Guns",
    "Light Machine Guns",
    "Belt-Fed",
    "Bolt Action",
    "Semi-Auto",
    "Pistols",
    "Marksman",
  ],

  Historical: [
    "WWII",
    "Vietnam",
    "Cold War Era",
    "British",
    "Korea",
    "Eastern Bloc",
    "Israeli",
  ],

  Technical: [
    "Modern Warfare",

    "Bullpup Design",
    "NATO Standard",
    "Urban Combat",
    "Parabellum",
    "German Engineering",
    "Swiss Precision",
    "Suppressed"
  ],

  Appeal: [
    "Top Rated",
    "Movie Famous",
    "Collector's Item",
    "Battle Tested",
  ],

  Skill: ["Beginner", "Extreme"]
};

export const category_descriptions = {
  "Pick 5": "Mix and match with this package and choose any five guns from our collection for $250",
  "Extreme": "The biggest, loudest, and flashiest firearms in our collection.",
  "Modern Warfare": "Feel the future of firearms with a custom selection of modern firearms from various countries around the world.",
  "WWII": "Relive history with iconic firearms from the battlefields of World War II.",
  "Vietnam": "Experience what it was like to fight in the Vietnam War with a selection of iconic firearms from the conflict.",
  "Assault & Battle Rifles": "Versatile rifles built for frontline domination and tactical precision.",
  "Submachine Guns": "Compact automatic weapons ideal for close-quarters combat and speed.",
  "Light Machine Guns": "Sustained firepower to control the battlefield and suppress the enemy.",
  "Belt-Fed": "Feed the beast - high-capacity automatic weapons with unrelenting fire.",
  "Bolt Action": "Classic precision and power - every shot deliberate and deadly.",
  "Semi-Auto": "Reliable and responsive for rapid follow-up shots with pinpoint control.",
  "Pistols": "Sidearms for speed, skill, and close encounters.",
  "Marksman": "Reach out and touch with rifles built for long-range lethality.",
  "Cold War Era": "Tensions were high, and so were the stakes - wield the arms of espionage and stand-offs.",
  "British": "Precision and pedigree from the empire that never surrendered.",
  "Korea": "Battle-tested weapons from a frozen warzone.",
  "Soviet Union": "Rugged, relentless, and reliable - the iron tools of the Red Army.",
  "Eastern Bloc": "Utilitarian power from behind the Iron Curtain.",
  "Israeli": "Battle-hardened engineering forged in modern conflict.",
  "German Engineering": "Meticulously crafted, fearsomely efficient.",
  "Swiss Precision": "Clean lines and cold precision - firepower with finesse.",
  "American Classic": "Stars, stripes, and serious stopping power.",
  "Parabellum": "Classic caliber, legendary performance - prepare for war.",
  "Bullpup Design": "Shorter, faster, deadlier - modern layouts for modern combat.",
  "NATO Standard": "Battle-tested and alliance-approved.",
  "Heavy Hitter": "Big bore, big recoil, big results.",
  "Urban Combat": "Tactical firepower designed for tight spaces and fast reactions.",
  "Top Rated": "Fan favorites - the most loved weapons on the range.",
  "Movie Famous": "Live your action hero fantasy - weapons from the silver screen.",
  "Collector's Item": "Rare, iconic, and unforgettable - history in your hands.",
  "Battle Tested": "Proven in combat, trusted by soldiers.",
  "Beginner": "User-friendly firearms perfect for new shooters.",
  "Suppressed": "Shoot Suppressed: Add a silencer for $20"
}

export interface Guns {
  id: string;
  title: string;
  price: string;
  description: string;
  images: string[];
  category: string;
  likes: number;
}

export const items: Guns[] = [
  {
    id: "modern_package",
    title: "Modern Warfare Package",
    price: "300",
    description: `Feel the future of firearms with a custom selection of modern firearms from various countries around the world.
<table border="0" cellspacing="0" cellpadding="5">
  <tr>
    <td>✓ P90</td>
    <td>✓ Kriss Vector</td>
  </tr>
  <tr>
    <td>✓ M4</td>
    <td>✓ Galil</td>
  </tr>
  <tr>
    <td>✓ Barrett</td>
    <td>✓ M249 SAW</td>
  </tr>
  <tr>
    <td>✓ M1014 Benelli</td>
    <td></td>
  </tr>
</table>
`,
    images: [
      "/img/guns/Modern_Rect.png",
      "/img/guns/_submachine/p90/p90.jpg",
      "/img/guns/_submachine/kriss_vector/kriss_vector.jpg",
      "/img/guns/_assault/m4/m4.jpg",
      "/img/guns/_assault/galil/GALIL.jpg",
      "/img/guns/_semi/barrett/barrett_50_cal.jpg",
      "/img/guns/_belt/saw/saw.jpg",
      "/img/guns/_semi/benelli/benelli_m1014.jpg",
    ],
    category: "Modern Warfare, Packages",
    likes: 9999
  },
  {
    id: "extreme_package",
    title: "Extreme Package",
    price: "500",
    description: `Looking for something a little more flashy? The Extreme Package features the biggest, loudest, and flashiest firearms in our collection. From the Kriss Vector shooting 1,200 rounds/minute to the yap of the Barking Chihuahua, this package will not disappoint.
<table border="0" cellspacing="0" cellpadding="5">
  <tr>
    <td>✓ Kriss Vector</td>
    <td>✓ M92</td>
  </tr>
  <tr>
    <td>✓ HK-51</td>
    <td>✓ Barking Chihuahua</td>
  </tr>
  <tr>
    <td>✓ M82A1 Barrett</td>
    <td>✓ .50 cal M2HB</td>
  </tr>
</table>

`,
    images: [
      "/img/guns/Extreme_Rect.png",
      "/img/guns/_submachine/kriss_vector/kriss_vector.jpg",
      "/img/guns/_assault/m92/M92.jpg",
      "/img/guns/_assault/hk51/HK51.jpg",
      "/img/guns/_assault/barking_chihuahua/barking_chihuahua.jpg",
      "/img/guns/_semi/barrett/barrett_50_cal.jpg",
      "/img/guns/_belt/m2hb/m2hb.jpg",
    ],
    category: "Extreme, Packages",
    likes: 9999
  },
  {
    id: "wwii_package",
    title: "WWII Package",
    price: "340",
    description: `Relive history from one of the most memorable conflicts to date.
This package contains firearms from both the Axis and Allied powers for the full World War II experience.
<table border="0" cellspacing="0" cellpadding="5">
  <tr>
    <td>✓ M1 Thompson</td>
    <td>✓ MP-40</td>
  </tr>
  <tr>
    <td>✓ M1 Garand</td>
    <td>✓ Bren</td>
  </tr>
  <tr>
    <td>✓ Mosin Nagant</td>
    <td>✓ DP-28</td>
  </tr>
  <tr>
    <td>✓ MG42</td>
    <td>✓ Sterling</td>
  </tr>
</table>
`,
    images: [
      "/img/guns/WWII_Rect.png",
      "/img/guns/_submachine/m1_thompson/m1_thompson.jpg",
      "/img/guns/_submachine/mp40/mp40.jpg",
      "/img/guns/_semi/m1_garand/m1_garand.jpg",
      "/img/guns/_light/bren/bren.jpg",
      "/img/guns/_bolt/mosin_nagant/mosin_nagant.jpg",
      "/img/guns/_light/dp_28/dp_28.jpg",
      "/img/guns/_belt/mg42/mg_42.jpg",
      "/img/guns/_submachine/sterling/Sterling.jpg",
    ],
    category: "WWII, Packages",
    likes: 9999
  },
  {
    id: "vietnam_package",
    title: "Vietnam Package",
    price: "260",
    description: `Experience what it was like to fight in the Vietnam War with a selection of iconic firearms from the conflict.
<table border="0" cellspacing="0" cellpadding="5">
  <tr>
    <td>✓ M16A1</td>
    <td>✓ AK-47</td>
  </tr>
  <tr>
    <td>✓ M14</td>
    <td>✓ SKS</td>
  </tr>
  <tr>
    <td>✓ RPD</td>
    <td>✓ M60</td>
  </tr>
</table>

`,
    images: [
      "/img/guns/Vietnam_Rect.png",
      "/img/guns/_assault/m16a1/m16_a1.jpg",
      "/img/guns/_assault/ak_47/ak-47.jpg",
      "/img/guns/_assault/m14/m14.jpg",
      "/img/guns/_semi/sks/SKS.jpg",
      "/img/guns/_belt/rpd/rpd.jpg",
      "/img/guns/_belt/m60/m60.jpg"
    ],
    category: "Vietnam, Packages",
    likes: 9999
  },
  {
    id: "beretta_m9",
    title: "Beretta M9",
    price: "35",
    description: `Developed in Italy in 1985, the Beretta M9 is a reliable semi-automatic pistol adopted by the United States military as their service pistol in 1985. It was chosen due to its survivability in a number of conditions including exposure to temperature ranges between -40°F to 140°F, salt water corrosion, repeated drops on concrete, and being buried in sand, mud, and snow.`,
    images: [
      "/img/guns/_pistols/beretta/beretta.jpg",
      "/img/guns/_pistols/beretta/beretta_military.jpg",
      "/img/guns/_pistols/beretta/beretta_diehar.jpg"
    ],
    category: "Pistols, Beginner, NATO Standard, Battle Tested, Movie Famous",
    likes: 4
  },
  {
    id: "1911",
    title: "M1911",
    price: "35",
    description: `The M1911 is a single-action, recoil-operated pistol chambered for .45 ACP. Designed in 1911 by John Browning, the M1911 is the best-known of his designs that use the short recoil design. It was widely copied with its operation system later becoming the preeminent type of the 20th century and a majority of all modern centerfire pistols. The M1911 served as the standard-issue sidearm for the United States Armed Forces from 1911 to 1985.`,
    images: [
      "/img/guns/_pistols/1911/1911.jpg",
      "/img/guns/_pistols/1911/1911_suppressed.jpg",
      "/img/guns/_pistols/1911/1911_military.jpeg",
      "/img/guns/_pistols/1911/1911_terminator.jpg",
    ],
    category: "Pistols, Battle Tested, Collector's Item, Movie Famous, Suppressed",
    likes: 5
  },
  {
    id: "nagant_m1895",
    title: "Nagant M1895",
    price: "35",
    description: `The Nagant M1895 Revolver is a seven-shot, gas-seal revolver designed and produced by Belgian industrialist Leon Nagant for the Russian Empire. The Nagant M1895 was adopted as the standard issue sidearm for the Imperial Russian Army and police officers. It became a widely recognized pistol in Russia and continued to be used up until 1952. Designed in 1886, the Nagant M1895 was chambered for a proprietary cartridge, 7.62x38mmR, and featured an unusual "gas-seal" system, in which the cylinder moved forward when the gun was cocked, to close the gap between the cylinder and the barrel, providing a boost to the muzzle velocity of the bullet and allowing the weapon to be suppressed (an unusual characteristic for a revolver).`,
    images: [
      "/img/guns/_pistols/nagant_m1895/nagant_m1895.jpg"
    ],
    category: "Pistols, Eastern Bloc, Collector's Item",
    likes: 2
  },
  {
    id: "30_watercooled",
    title: "M1917 Browning",
    price: "65",
    description: `The .30 cal water-cooled Browning is a heavy machine gun designed by John M. Browning throughout the early 1900's. First introduced in 1917, the United States armed forces used it in WWI, WWII, and the Korean War and was used in service until the late 1960's. It was a crew-served, belt-fed, water-cooled machine gun that was used as a battalion level, and often mounted on vehicles (such as a jeep). The water cooling system surrounded the barrel with water which then turned to steam when heated. The steam was moved off via tube that allowed for the water to be re-used.`,
    images: [
      "/img/guns/_belt/water-cooled/30_cal_water-cooled.jpg",
      "/img/guns/_belt/water-cooled/old_watercooled.jpg",
      "/img/guns/_belt/water-cooled/watercooled_jungle.jpg",
    ],
    category: "Belt-Fed, WWII, Korea, Battle Tested",
    likes: 7
  },
  {
    id: "1928_thompson",
    title: "1928 Thompson",
    price: "49",
    description: `The M1928 Thompson was the first version of the Thompson to be widely used by military forces. It had provisions for a box and drum magazine, but the latter proved to be heavy and noisy when used. The M1928 also featured a delayed blowback action and cooling fins on the barrel. However because the drum magazines were slow and heavy, the development of the M1 Thompson began in 1942 to further simplify the design.`,
    images: [
      "/img/guns/_submachine/m1928_thompson/m1928_thompson.jpg",
      "/img/guns/_submachine/m1928_thompson/M1928-Thompson-(gangster).jpg",
      "/img/guns/_submachine/m1928_thompson/soldier_1928.jpg",
      "/img/guns/_submachine/m1928_thompson/seanpenn_m1928.jpg",
    ],
    category: "Submachine Guns, WWII, Pick 5, Movie Famous, Collector's Item, Top Rated",
    likes: 12
  },
  {
    id: "m1_thompson",
    title: "M1 Thompson",
    price: "49",
    description: `In order to simplify the M1928 Thompson, development on the M1 began in 1942. The M1's were issued with a 30-round box magazine and could use the earlier 20-round box. The M1 also had a barrel without cooling fins, a simplified rear sight, and had a straight blowback action. The majority of the Thompsons issued for WWII were the simplified M1 and M1A1 variants.`,
    images: [
      "/img/guns/_submachine/m1_thompson/m1_thompson.jpg",
      "/img/guns/_submachine/m1_thompson/soldier_m1thompson.jpg",
      "/img/guns/_submachine/m1_thompson/privateryan_m1thompson.jpg"
    ],
    category: "Submachine Guns, WWII, Pick 5, Movie Famous, Battle Tested, Top Rated",
    likes: 15
  },
  {
    id: "p90",
    title: "P90",
    price: "75",
    description: `The P90 is a compact personal defense weapon, also known as a PDW, that was designed to replace 9x19mm Parabellum firearms. Compact yet powerful, the P90 has been effective for vehicle crews, support personnel, and counter-terrorist groups. While development started in 1986, production began later in 1990 which is where the "90" in the name comes from and when the ammunition was redesigned and shortened.`,
    images: [
      "/img/guns/_submachine/p90/p90.jpg",
      "/img/guns/_submachine/p90/p90_modern.jpg",
      "/img/guns/_submachine/p90/james_bond_p90.jpg"
    ],
    category: "Submachine Guns, Modern Warfare, Parabellum, Pick 5, NATO Standard, Movie Famous, Top Rated",
    likes: 22
  },
  {
    id: "uzi",
    title: "Uzi",
    price: "49",
    description: `The Uzi is an Israeli open-bolt, blowback-operated family of submachine guns. Developed in the 1940's by Major Uziel Gal, the Uzi was later introduced to IDF special forces in 1954. Cheap to produce and easy to strip for maintenance, the Uzi became widely used by military and law enforcement in the 1960's through the 1980's.`,
    images: [
      "/img/guns/_submachine/uzi/Uzi.jpg",
      "/img/guns/_submachine/uzi/uzi_suppressed.jpg",
      "/img/guns/_submachine/uzi/dutch_soldier_uzi.jpg",
      "/img/guns/_submachine/uzi/terminator_uzi.jpg"
    ],
    category: "Submachine Guns, Israeli, Movie Famous, Battle Tested, Urban Combat, Cold War Era, Suppressed",
    likes: 8
  },
  {
    id: "m3a1_grease_gun",
    title: "M3A1 Grease Gun",
    price: "49",
    description: `The M3 is a .45 caliber submachine gun developed in 1942 to be a replacement to the Thompson submachine gun. It received its nickname "Grease Gun" because of how similar it looked to the mechanics tool. The M3A1 is a modernized variant of the M3 and contains several improvements that provided for a more reliable, lighter weight, and easier to maintain submachine gun.`,
    images: [
      "/img/guns/_submachine/m3a1_greasegun/m3a1_grease_gun.jpg",
      "/img/guns/_submachine/m3a1_greasegun/greasegun_tanker.jpg",
      "/img/guns/_submachine/m3a1_greasegun/soldier_greasegun.jpg"
    ],
    category: "Submachine Guns, Battle Tested, Top Rated",
    likes: 13
  },
  {
    id: "pps_43",
    title: "PPs-43",
    price: "49",
    description: `The PPS is a family of Soviet submachine guns developed in the early 1940's chambered in 7.62x25mm Tokarev. Designed by Alexei Sudayeva, the PPS was a low-cost personal defense weapon that was used by vehicle crews and support service personnel. This family of firearms and its variants were used by the Red Army in World War II and later on by other countries in Africa and Asia. The PPS-43 gets its name from the year it was produced, 1943.`,
    images: [
      "/img/guns/_submachine/pps_43/pps-43.jpg",
      "/img/guns/_submachine/pps_43/wwii_pps43.jpg",
      "/img/guns/_submachine/pps_43/PPS-43_section.jpg"
    ],
    category: "Submachine Guns, Eastern Bloc, Battle Tested",
    likes: 6
  },
  {
    id: "vz_61",
    title: "VZ-61",
    price: "49",
    description: `The Skorpion vz. 61 is a Czechoslovak machine pistol developed in 1959 by Miroslav Rybar. It was produced from 1963-1979 and was initially developed for use with security forces. The weapon was also accepted into service with the Czechoslovak Army as a personal sidearm for lower-ranking army staff. It has made several appearances in pop culture media including The Matrix, Body of Lies, and Captain America: The Winter Soldier. The VZ61 is a select-fire, straight blowback-operated weapon that fires from the closed bolt position. The compact dimensions were achieved by using a telescopic bolt assembly that wraps around a considerable portion of the barrel.`,
    images: [
      "/img/guns/_submachine/vz-61/vz-61.jpg",
      "/img/guns/_submachine/vz-61/vz-61_military.jpg",
      "/img/guns/_submachine/vz-61/vz-61_goldeneye.jpg"
    ],
    category: "Submachine Guns, Movie Famous, Cold War Era, Eastern Bloc",
    likes: 0
  },
  {
    id: "sten_mk_v",
    title: "Sten Mk V",
    price: "49",
    description: `The Sten Mk V was introduced in 1944 and was a higher quality version of the Mk II. Changes to the design included a wooden pistol grip, a vertical wooden fore grip, and a wooden stock. With higher quality in manufacture and finish than the Mk II and Mk III, some variants of the Mk V featured a swivel stock and rear sight mirror for firing around corners in urban warfare.`,
    images: [
      "/img/guns/_submachine/sten_mkv/sten_mkv.jpg",
      "/img/guns/_submachine/sten_mkv/sten_soldier.jpg",
      "/img/guns/_submachine/sten_mkv/soldier_stenmkv.jpg"
    ],
    category: "Submachine Guns, Battle Tested, Urban Combat",
    likes: 8
  },
  {
    id: "1919a4",
    title: "1919A4",
    price: "65",
    description: `The M1919 Browning is a .30 caliber medium machine gun that was widely used during the 20th century. It was used as a light infantry, coaxial, mounted, aircraft, and anti-aircraft machine gun by the U.S. and many other countries, especially during World War II, the Korean War, and the Vietnam War.`,
    images: [
      "/img/guns/_belt/1919/browning-m1919.jpg",
      "/img/guns/_belt/1919/a14mach.jpg",
      "/img/guns/_belt/1919/1919a4_desr.jpeg"
    ],
    category: "Belt-Fed, Korea, Battle Tested, Top Rated",
    likes: 74
  },
  {
    id: "ak_47",
    title: "AK-47",
    price: "55",
    description: `The AK family of automatic rifles was developed in the Soviet Union post WWII. The AK-47 is the original firearm of the AK family with the number 47 referring to the year it was finished. It is gas-operated and uses the 7.62x39mm cartridge. It became widely popular because of its dependability under harsh conditions and low production costs, remaining popular today after almost 70 years.`,
    images: [
      "/img/guns/_assault/ak_47/ak-47.jpg",
      "/img/guns/_assault/ak_47/ak47_russian.jpg",
      "/img/guns/_assault/ak_47/ak47_reddawn.jpg"
    ],
    category: "Assault & Battle Rifles, Vietnam, Pick 5, Eastern Bloc, Cold War Era, Battle Tested, Collector's Item, Movie Famous, Top Rated",
    likes: 16
  },
  {
    id: "ak_47_gold",
    title: "Gold AK-47",
    price: "55",
    description: `The AK-47 is the original firearm of the AK family with the number 47 referring to the year it was finished. It became widely popular because of its dependability under harsh conditions and low production costs, remaining popular today after almost 70 years.`,
    images: [
      "/img/guns/_assault/ak47_gold/ak-47_gold.jpg",
      "/img/guns/_assault/ak47_gold/gold_ak47.jpeg"
    ],
    category: "Assault & Battle Rifles, Eastern Bloc, Collector's Item, Movie Famous, Top Rated",
    likes: 16
  },
  {
    id: "ak_74",
    title: "AK-74",
    price: "55",
    description: `The AK-74 is an assault rifle developed in the early 1970's by Soviet weapons designer Mikahil Kalashnikov to replace the earlier AKM (a refined version of the AK-47). It uses a smaller 5.45x39mm cartridge, replacing the 7.62x39mm chambering of earlier Kalasnikov-pattern firearms. It first saw service in the 1979 Afghanistan conflict and is currently used in various countries of the former Soviet Union.`,
    images: [
      "/img/guns/_assault/ak_74/AK74.jpg",
      "/img/guns/_assault/ak_74/ak_74_winter.jpg",
      "/img/guns/_assault/ak_74/ak_74_soldier.jpg"
    ],
    category: "Assault & Battle Rifles, Eastern Bloc, Cold War Era, Battle Tested",
    likes: 5
  },
  {
    id: "ak_74u",
    title: "AK-74u",
    price: "55",
    description: `The AK-74 served as a replacement for the AKM, a simplified version of the AK-47. It uses a smaller 5.45x39mm cartridge rather than the 7.62x39mm cartridge of earlier Kalashnikov weapons. Because of the smaller caliber, the AK-74 has a better effective range, firing accuracy, and reliability. It also uses a shorter, 8.1 in, barrel making it more maneuverable in tight quarters.`,
    images: [
      "/img/guns/_assault/ak_74u/ak-74u.jpg",
      "/img/guns/_assault/ak_74u/ak-74u_russianforces.jpg",
      "/img/guns/_assault/ak_74u/ak74u_soldiers.jpg"
    ],
    category: "Assault & Battle Rifles, Eastern Bloc, Urban Combat, Top Rated",
    likes: 10
  },
  {
    id: "amd65",
    title: "AMD65",
    price: "55",
    description: `The AMD65 or Automata Modositott Deszant 1965 is a licensed variant of the AKM rifle that was manufactured by Hungary. Developed in 1965, it first saw service in 1967 and was used by the armored infantry and paratrooper units of the Hungarian Defense Forces. Today it is used in various western security forces including private military and contract employees.`,
    images: [
      "/img/guns/_assault/amd65/AMD65.jpg",
      "/img/guns/_assault/amd65/amd65_police.jpg",
      "/img/guns/_assault/amd65/amd65_female.jpg"
    ],
    category: "Assault & Battle Rifles, Eastern Bloc, Cold War Era",
    likes: 4
  },
  {
    id: "apc9k",
    title: "APC9K",
    price: "49",
    description: `The B&T APC (Advanced Police Carbine) is a family of firearms produced and manufactured by B&T of Switzerland. Announced in 2011, the submachine gun series uses 9x19mm, .40 S&W (APC40), 10mm Auto (APC10) and .45 ACP ammunition. The series was designed in the 2000s as a modern submachine gun that would be cheaper to produce. The APC9K is a shortened barrel variant of the APC9 which is the basic model and adopts a polymer receiver, magazine, and folding stock. It can be loaded with either 15-,20-,25-, or 30-round magazines. This model along with other variants of the APC are currently used in the U.S among personal security and police departments.`,
    images: [
      "/img/guns/_submachine/apc9k/apc9k.jpg"
    ],
    category: "Submachine Guns, Swiss Precision, Urban Combat",
    likes: 2
  },
  {
    id: "eddystone",
    title: "Eddystone",
    price: "40",
    description: `The M1917 Enfield is an American modification and production of the .303-inch (7.7 mm) Pattern 1914 Enfield (P14) rifle. Developed during 1917-1918, it was the main rifle used by the American Expeditionary Forces in Europe during World War I. As the UK entered World War I, it needed more manufacturers for the newly developed Pattern 1913 Enfield. Thus the U.S were given contracts to make them and while the UK had made them chambered in .276 Enfield cartridge, the rifles made in the U.S were chambered in the old .303 for convenience of ammunition logistics. Winchester and Remington were selected to manufacture these new rifles including a subsidiary of Remington, Eddystone Arsenal. Thus, three variations of the rifle exist, labeled "Winchester," "Remington" or "Eddystone".`,
    images: [
      "/img/guns/_bolt/eddystone/eddystone.jpg"
    ],
    category: "Bolt Action, Battle Tested, Collector's Item",
    likes: 1
  },
  {
    id: "f2000",
    title: "F2000",
    price: "55",
    description: `The F2000 is a 5.56x45mm NATO bullpup rifle, designed by FN Herstal in Belgium. Gas-operated and fully automatic, the F2000 is a selective fire weapon operating from a closed bolt. Both safety system and trigger mechanism were adopted from the P90 personal defense weapon. Using a unique ejection system, the F2000 is a fully ambidextrous, bullpup rifle with the spent cartridge casings being ejected forward and to the right side of the weapon through a tube running above the barrel.`,
    images: [
      "/img/guns/_assault/f2000/f2000.jpg",
      "/img/guns/_assault/f2000/f2000_soldiers.jpg",
      "/img/guns/_assault/f2000/Combined_Resolve_II_(14064035579)-(1).jpg"
    ],
    category: "Assault & Battle Rifles, Bullpup Design, NATO Standard",
    likes: 3
  },
  {
    id: "glock_17",
    title: "Glock 17 Gen5",
    price: "35",
    description: `The Glock 17, designed in the 1980s, is the first pistol made by Glock Ges.m.b.H and is named after the 17th patent procured by the company. Made with synthetic materials and modern manufacturing technologies, the Glock 17 became a cost effective option compared to other pistols. In 2017, the company presented the Gen 5 with revisions centered on ergonomics and improving reliability.`,
    images: [
      "/img/guns/_pistols/glock/glock.jpg",
      "/img/guns/_pistols/glock/glock_military.jpeg",
      "/img/guns/_pistols/glock/glock_madmax.jpg"
    ],
    category: "Pistols, Beginner, NATO Standard, Battle Tested, Movie Famous",
    likes: 1
  },
  {
    id: "g3_hk91",
    title: "G3/HK91",
    price: "55",
    description: `The G3 is a select-fire battle rifle developed in the 1950's using 7.62x51mm NATO rounds. The G3 is a selective-fire automatic weapon that uses a roller-delayed blowback operating system. The HK91 is a redesigned HK41, which is a semi automatic version of the G3, and was produced for the civilian market in the 1960's. However due to an import ban in 1989 by President Bush, few HK91s made it to the U.S market. As a result, the HK91 remains valuable to collectors today.`,
    images: [
      "/img/guns/_assault/g3_hk91/g3_hk91.jpg",
      "/img/guns/_assault/g3_hk91/g3_tank.jpg",
      "/img/guns/_assault/g3_hk91/g3_soldier.jpg"
    ],
    category: "Assault & Battle Rifles, German Engineering, Cold War Era, NATO Standard, Battle Tested, Collector's Item",
    likes: 4
  },
  {
    id: "galil",
    title: "Galil",
    price: "55",
    description: `The IMI Galil is a family of Israeli automatic rifles developed in the 1960's. Designed by Yisrael Galil and Yaacov Lior, they were produced by Israel Military Industries (IMI). The design of the Galil was based off of thousands of AK-47s captured during the Six-Day War. The Israelis found they were more reliable and controllable than the FAL they were using at the time. They are currently in use with military and police forces in over 25 countries.`,
    images: [
      "/img/guns/_assault/galil/GALIL.jpg",
      "/img/guns/_assault/galil/galil_old.jpg",
      "/img/guns/_assault/galil/galil_soldier.jpg"
    ],
    category: "Assault & Battle Rifles, Modern Warfare, Israeli, Pick 5, Battle Tested, NATO Standard",
    likes: 3
  },
  {
    id: "hk_51",
    title: "HK51",
    price: "55",
    description: `The HK51 is a variant of the G3 which is a select-fire battle rifle developed in the 1950's by Heckler & Koch. The HK51 in particular is not made by H&K, and is rather a creation of the American Class II manufacturing after-market. While the HK51 does not have any real standards, it is usually a modified G3A3, or the semi automatic HK41 and HK91, with MP5 furniture and accessories as well as a collapsible stock.`,
    images: [
      "/img/guns/_assault/hk51/HK51.jpg",
      "/img/guns/_assault/hk51/hk51_cool.jpg",
      "/img/guns/_assault/hk51/hk51_walkingdead.jpg"
    ],
    category: "Assault & Battle Rifles, Extreme, Pick 5, German Engineering, Urban Combat, Movie Famous",
    likes: 8
  },
  {
    id: "hk_ump",
    title: "HK UMP",
    price: "49",
    description: `The HK UMP is a German submachine gun developed in the 1990s by Heckler & Koch as a lighter and cheaper option to the MP5, despite both remaining in production. It can be interchangeable between 3 calibers: the UMP45 (.45 ACP), the UMP40 (.40 S&W), and the UMP9 (9x19mm Parabellum). The HK UMP has been used by several agencies and military forces including the U.S Customs and Border Protection.`,
    images: [
      "/img/guns/_submachine/hk_ump/hk_ump.jpg",
      "/img/guns/_submachine/hk_ump/ump40_swat.jpg",
      "/img/guns/_submachine/hk_ump/movie_hkump.jpg"
    ],
    category: "Submachine Guns, Parabellum, German Engineering, Urban Combat, Movie Famous",
    likes: 2
  },
  {
    id: "kar_98",
    title: "Kar 98",
    price: "40",
    description: `The Karabiner 98 kurz, also known as the Kar98k, is a bolt-action rifle that was adopted by the German Wehermacht as their standard service rifle in 1935. Chambered for the 7.92x57mm Mauser cartridge, the Kar98k was noted for its reliability, accuracy, and range of up to 550 yards with iron sights. It remained the primary German service rifle until millions of them were captured by the Soviets in 1945 at the end of WWII.`,
    images: [
      "/img/guns/_bolt/kar98/kar_98.jpg",
      "/img/guns/_bolt/kar98/kar98_soldier.jpg",
      "/img/guns/_bolt/kar98/kar98_training.jpg"
    ],
    category: "Bolt Action, German Engineering, Battle Tested, Collector's Item, Marksman",
    likes: 10
  },
  {
    id: "kriss_vector",
    title: "Kriss Vector",
    price: "49",
    description: `The Kriss Vector is a series of weapons all based on the parent submachine gun developed by American firearms and defense company, Kriss USA. Originally designed in 2006, the Kriss Vector has an articulated mechanism known as the "Kriss Super V" that allows the bolt to move down behind the magazine well. In theory, the energy moves downward instead of rearward resulting in less felt recoil. At 1400 rnds/min, it is used in select countries with the company announcing the development of several variants.`,
    images: [
      "/img/guns/_submachine/kriss_vector/kriss_vector.jpg",
      "/img/guns/_submachine/kriss_vector/vector_suppressed.jpg",
      "/img/guns/_submachine/kriss_vector/resident_evil_vector.jpg",
      "/img/guns/_submachine/kriss_vector/cable_krissvector.jpg"
    ],
    category: "Submachine Guns, Modern Warfare, Extreme, Urban Combat, Movie Famous, Suppressed",
    likes: 10
  },
  {
    id: "l1a1",
    title: "L1A1",
    price: "55",
    description: `The L1A1 Self-Loading Rifle is a British version of the FN FAL battle rifle produced by the Belgian armaments manufacturer FN Herstal. The L1A1 is a slightly modified design that uses British imperial units. Notable differences include the magazines and the butt-stock which attach differently. The L1A1 served as the UK's first-line battle rifle for nearly 30 years before being replaced by the 5.56mm L85A1 in the 1980s.`,
    images: [
      "/img/guns/_semi/l1a1/l1a1.jpg"
    ],
    category: "Semi-Auto, WWII, British, Pick 5, NATO Standard, Cold War Era, Battle Tested",
    likes: 1
  },
  {
    id: "lee_enfield",
    title: "Lee-Enfield",
    price: "40",
    description: `The Lee-Enfield is a British bolt-action, magazine-fed, repeating rifle and was the main firearm used by the military of the British Empire and Commonwealth during the first part of the 20th century. It was the standard rifle from 1895, when it was first adopted, until 1957.`,
    images: [
      "/img/guns/_bolt/lee_enfield/lee_enfield.jpg",
      "/img/guns/_bolt/lee_enfield/enfield_training.jpg",
      "/img/guns/_bolt/lee_enfield/enfield_modern.jpg"
    ],
    category: "Bolt Action, British, Battle Tested, Collector's Item",
    likes: 6
  },
  {
    id: "dp_28",
    title: "DP-28",
    price: "59",
    description: `The Degtyaryov machine gun or DP-28 is a light machine gun firing the 7.62x54mmR cartridge that was used by the Soviet Union after its deployment in 1928. Used in aircrafts and equipped on all Soviet tanks in WWII, one of the DP-28's defining characteristics was the pancake magazine it used which led to its nickname "the record player". However these magazines were easily damaged while being transported and were time consuming to reload.`,
    images: [
      "/img/guns/_light/dp_28/dp_28.jpg",
      "/img/guns/_light/dp_28/dp28_march.jpg",
      "/img/guns/_light/dp_28/Korean_War_HA-SN-98-07010.jpg"
    ],
    category: "Light Machine Guns, WWII, Pick 5, Eastern Bloc, Battle Tested",
    likes: 4
  },
  {
    id: "bren",
    title: "Bren",
    price: "59",
    description: `Bren is a series of light machine guns developed by Britain in the 1930s and used in various roles until 1992. It features a distinctive top-mounted curved box magazine, conical flash hider, and quick change barrel. The name Bren was derived from Brno, the Czechoslovak city in Moravia, where the Zb vz. 26 was designed and Enfield, site of the British Royal Arms Factory. Gas-operated, the Bren used the same .303 ammunition as the standard British bolt-action rifle, the Lee-Enfield, firing at a rate of between 480 and 540 rounds per minute (rpm) depending on the mode.`,
    images: [
      "/img/guns/_light/bren/bren.jpg",
      "/img/guns/_light/bren/bren_wwii.jpg",
      "/img/guns/_light/bren/trench_bren.jpg"
    ],
    category: "Light Machine Guns, British, Battle Tested",
    likes: 5
  },
  {
    id: "mg15",
    title: "MG 15",
    price: "59",
    description: `The MG 15 is a German 7.92 mm machine gun developed as a hand manipulated gun for combat aircraft in the early 1930's. By 1941, it was replaced in aircraft combat and found use for it with ground troops. Developed from the MG 30, the MG 15 fires from the open bolt position at a rate of over 1,000 rounds per minute.`,
    images: [
      "/img/guns/_light/mg_15/mg15.jpg",
      "/img/guns/_light/mg_15/mg15_aircraft.jpg",
      "/img/guns/_light/mg_15/mg15_wwii.jpg"
    ],
    category: "Light Machine Guns, German Engineering",
    likes: 5
  },
  {
    id: "bar",
    title: "BAR",
    price: "59",
    description: `The Browning Automatic Rifle (BAR or B.A.R) is a family of American automatic rifles and machine guns used by the United States and numerous other countries during the 20th century. The primary variant of the BAR series was the M1918, chambered for the .30-06 Springfield rifle cartridge and designed by John Browning in 1917. The BAR was designed to be carried by infantrymen during an assault advance while supported by the sling over the shoulder, or to be fired from the hip. The BAR saw extensive service in both World War II and the Korean War and saw limited service in the Vietnam War.`,
    images: [
      "/img/guns/_light/bar/BAR.jpg",
      "/img/guns/_light/bar/tank_BAR.jpg",
      "/img/guns/_light/bar/diagram_BAR.jpg"
    ],
    category: "Light Machine Guns, Korea, Battle Tested",
    likes: 5
  },
  {
    id: "m240",
    title: "M240",
    price: "65",
    description: `The M240 is a family of belt-fed machine guns that have been used in the United States Armed Forces since the 1970s. Widely used by infantry, this gas-operated, air-cooled medium machine gun is chambered in 7.62x51mm NATO. First manufactured in 1977, the M240 gained a reputation for versatility as seen by its ability to be fired from a bipod, mounted on a tripod, on ground vehicles, on watercraft and on aircraft. Highly regarded for its reliability, the M240 is still standard equipment for all units of the U.S. Army.`,
    images: [
      "/img/guns/_belt/m240/m240_1.jpg",
      "/img/guns/_belt/m240/m240_2.jpg"
    ],
    category: "Belt-Fed, NATO Standard, Battle Tested",
    likes: 1
  },
  {
    id: "m249_saw",
    title: "M249 SAW",
    price: "65",
    description: `The M249 is a light machine gun and an American version of the Belgian FN Minimi light machine gun. Formerly known as the M249 Squad Automatic Weapon (SAW), it provided squads with a high rate of fire with the accuracy and portability similar to a rifle. Gas operated and air-cooled, the M249 has a quick-change barrel that allows the gunner to quickly replace an overheated or jammed barrel.`,
    images: [
      "/img/guns/_belt/saw/saw.jpg",
      "/img/guns/_belt/saw/saw_gulf-war.jpg",
      "/img/guns/_belt/saw/saw_modern.jpg"
    ],
    category: "Belt-Fed, Modern Warfare, Pick 5, NATO Standard, Battle Tested, Top Rated",
    likes: 11
  },
  {
    id: "m2hb",
    title: "M2HB .50 cal",
    price: "349",
    description: `The M2 Machine Gun or Browning .50 Caliber Machine Gun is a heavy machine gun designed towards the end of World War I by John Browning. The M2 has been referred to as "Ma Deuce", as a GI phonetic slang or "the fifty" in reference to its caliber. It is effective against infantry, unarmored or lightly armored vehicles and boats, light fortifications and low-flying aircraft. The M2 machine gun has been in production longer than any other machine gun.`,
    images: [
      "/img/guns/_belt/m2hb/m2hb.jpg",
      "/img/guns/_belt/m2hb/m2hb_wwii.jpg",
      "/img/guns/_belt/m2hb/m2hb_modern.jpg"
    ],
    category: "Belt-Fed, Extreme, Battle Tested, Movie Famous, Top Rated",
    likes: 120
  },
  {
    id: "m60",
    title: "M60",
    price: "65",
    description: `The M60 is a family of machine guns developed in the late 1950's using 7.62x51mm NATO cartridges. Several types of ammunition are approved for the M60 including ball, tracer, and armor-piercing rounds. Serving with every branch of the U.S military and still serving with the armed forces of other states, its manufacture and continued upgrade for military and commercial purchase continues into the 21st century.`,
    images: [
      "/img/guns/_belt/m60/m60.jpg",
      "/img/guns/_belt/m60/m60_sneaky.jpg",
      "/img/guns/_belt/m60/vietnam_m60.jpg"
    ],
    category: "Belt-Fed, Vietnam, Pick 5, NATO Standard, Battle Tested, Movie Famous",
    likes: 6
  },
  {
    id: "mg42",
    title: "MG42",
    price: "65",
    description: `The MG 42 (shortened from German: Maschinengewehr 42, or "machine gun 42") was a 7.92×57mm Mauser general purpose machine gun that was developed in Nazi Germany and entered service with the Wehrmacht in 1942. The MG 42 has a proven record of reliability, durability, simplicity, and ease of operation, but is most notable for its ability to produce a high volume of suppressive fire.`,
    images: [
      "/img/guns/_belt/mg42/mg_42.jpg",
      "/img/guns/_belt/mg42/mg42_shoulder_mount.jpg",
      "/img/guns/_belt/mg42/mg42_renactment.jpg"
    ],
    category: "Belt-Fed, WWII, German Engineering, Battle Tested, Top Rated",
    likes: 96
  },
  {
    id: "minigun",
    title: "M134 Minigun 100 rnds.",
    price: "299",
    description: `The M134 Minigun is an American 7.62x51 mm NATO six-barrel rotary machine gun with a high rate of fire (2,000 to 6,000 rounds per minute). It features a Gatling-style rotating barrel assembly with an external power source, normally an electronic motor. The "mini" in the name is a comparison to the larger-caliber designs that use a rotary barrel design, such as the General Electric's earlier 20 mm M61 Vulcan, and "gun" for the use of rifle ammunition as opposed to autocannon shells.`,
    images: [
      "/img/guns/_belt/minigun/minigun.jpg",
      "/img/guns/_belt/minigun/minigun_vietnam.jpg",
      "/img/guns/_belt/minigun/terminator_minigun.jpg"
    ],
    category: "Belt-Fed, Movie Famous, Top Rated",
    likes: 12
  },
  {
    id: "minigun_2",
    title: "M134 Minigun 200 rnds.",
    price: "499",
    description: `The M134 Minigun is an American 7.62x51 mm NATO six-barrel rotary machine gun with a high rate of fire (2,000 to 6,000 rounds per minute). It features a Gatling-style rotating barrel assembly with an external power source, normally an electronic motor. The "mini" in the name is a comparison to the larger-caliber designs that use a rotary barrel design, such as the General Electric's earlier 20 mm M61 Vulcan, and "gun" for the use of rifle ammunition as opposed to autocannon shells.`,
    images: [
      "/img/guns/_belt/minigun/minigun.jpg",
      "/img/guns/_belt/minigun/minigun_vietnam.jpg",
      "/img/guns/_belt/minigun/terminator_minigun.jpg"
    ],
    category: "Belt-Fed, Movie Famous, Top Rated",
    likes: 12
  },
  {
    id: "pkm",
    title: "PKM",
    price: "65",
    description: `The PK is a belt-fed general-purpose machine gun, chambered for the 7.62x54mmR rimmed cartridge. Designed in the Soviet Union and currently in production in Russian, the original PK machine gun was introduced in 1961 and the improved PKM variant was introduced in 1969. The modified PKM later came out in 1969 and was designed to replace the SGM and RP-46 machine guns that were previously in Soviet service. The PKM aimed to reduce the weight, simplify production, and facilitate easier operation.`,
    images: [
      "/img/guns/_belt/pkm/pkm.jpg",
      "/img/guns/_belt/pkm/miltary_PKM.jpg",
      "/img/guns/_belt/pkm/modern_PKM.jpg"
    ],
    category: "Belt-Fed, Eastern Bloc, Battle Tested, Cold War Era",
    likes: 3
  },
  {
    id: "rpd",
    title: "RPD",
    price: "65",
    description: `The RPD is a 7.62 mm light machine gun that is a belt fed version of the DP machine gun of WWII. Developed by the Soviet Union in 1943, the RPD is a precursor to most squad automatic weapons (SAW) and was later replaced by the RPK. Designed to be simple, rugged and reliable, the RPD was replaced by the RPK in the 1960's, the RPD is still used in African and Asian nations.`,
    images: [
      "/img/guns/_belt/rpd/rpd.jpg",
      "/img/guns/_belt/rpd/rpd_egypt.jpg",
      "/img/guns/_belt/rpd/rpd_german.jpg"
    ],
    category: "Belt-Fed, Vietnam, Eastern Bloc, Battle Tested, Cold War Era",
    likes: 2
  },
  {
    id: "rpk",
    title: "RPK",
    price: "59",
    description: `The RPK is a Russian made 7.62x39mm light machine gun designed by Mikhail Kalashnikov in the 1960's. It eventually replaced the 7.62x39mm RPD light machine gun and is still used today in countries of the former Soviet Union and parts of African and Asian nations.`,
    images: [
      "/img/guns/_light/rpk/rpk.jpg",
      "/img/guns/_light/rpk/rpk_soldier.jpg",
      "/img/guns/_light/rpk/rpk_modern.jpg"
    ],
    category: "Light Machine Guns, Eastern Bloc, Cold War Era, Battle Tested",
    likes: 6
  },
  {
    id: "sig_m17",
    title: "SIG-M17",
    price: "35",
    description: `The SIG Sauer M17 and M18 are service pistols derived from the SIG Sauer P320 in use with the United States Armed Forces. The M17 is the full-sized model whereas the M18 is the shorter length carry model. Both models have been adopted by the Army, Navy, Marine Corps, Air Force, and Space Force. The pistol replaced the Beretta M9, as well as several other handguns across the services. The M17 has better accuracy and tighter dispersion than the Beretta M9.`,
    images: [
      "/img/guns/_pistols/sig_m17/sig_m17.jpg"
    ],
    category: "Pistols, Beginner, NATO Standard, Battle Tested",
    likes: 0
  },
  {
    id: "sig_m18",
    title: "SIG-M18",
    price: "35",
    description: `The SIG Sauer M18 is a service pistol derived from the SIG Sauer P320, used by the United States Armed Forces. Both the M17 and M18 replaced the Beretta M9. The M18 is the shorter length carry model.`,
    images: [
      "/img/guns/_pistols/sig_m18/sig_m18.jpg"
    ],
    category: "Pistols, NATO Standard, Battle Tested",
    likes: 0
  },
  {
    id: "sa26",
    title: "SA 26",
    price: "49",
    description: `The Sa 26 is a Czechoslovakian designed submachine gun that is part of a larger series of submachine guns introduced in 1948. Designed primarily by Jaroslav Holecek, this series is the best known of Czechoslovakian design. The Sa 26 features a folding metal stock as well as fixed wood stock. It is still seen today in various countries with the Sa 23 and 25 being more common.`,
    images: [
      "/img/guns/_submachine/sa26/SA26.jpg",
      "/img/guns/_submachine/sa26/sa26_photobw.jpg"
    ],
    category: "Submachine Guns, Eastern Bloc, Cold War Era",
    likes: 5
  },
  {
    id: "sterling",
    title: "Sterling",
    price: "49",
    description: `The Sterling is a British 9x19mm Parabellum submachine gun developed in 1944. With a successful and reliable design, it remained standard issue with the British Army until 1994, when it was replaced by the L85A1 assault rifle. The Star Wars films later used the Sterling as Stormtrooper blaster rifles with few cosmetic alterations.`,
    images: [
      "/img/guns/_submachine/sterling/Sterling.jpg",
      "/img/guns/_submachine/sterling/stormtrooper-blaster.jpg",
      "/img/guns/_submachine/sterling/sterling_troops.jpg"
    ],
    category: "Submachine Guns, WWII, British, Parabellum, Movie Famous, Battle Tested, Urban Combat",
    likes: 5
  },
  {
    id: "tavor_ts12",
    title: "Tavor TS12",
    price: "40",
    description: `The IWI Tavor TS12 is an Israeli semi-automatic bullpup shotgun, based on the IWI Tavor assault rifle. First making an appearance in 2018, the Tavor TS12 quickly became one of the best selling semi-automatic shotguns of 2020. Firing at a rate of 123 rnds/min, the TS12 uses a short stroke gas piston. It loads its shells into three magazine tubes, each of which contain a total of five shells, allowing for a maximum of 15+1. The tubes can be rotated via a button on the pistol grip.`,
    images: [
      "/img/guns/_semi/tavor/tavor_ts12.jpg"
    ],
    category: "Semi-Auto, Israeli, Bullpup Design",
    likes: 0
  },
  {
    id: "sten_mk_ii",
    title: "Sten Mk II",
    price: "49",
    description: `The Sten (or Sten gun) was a family of British 9 mm submachine guns used extensively by British and Commonwealth forces throughout World War II and the Korean War. They were notable for having a simple design and very low production cost making them effective insurgency weapons for resistance groups. The STEN Mk II was the most common variation of the STEN made, with over two million units produced.`,
    images: [
      "/img/guns/_submachine/sten_mkii/sten_mkii.jpg",
      "/img/guns/_submachine/sten_mkii/sten_mkii_soldiercolor.jpg",
      "/img/guns/_submachine/sten_mkii/bw_woman.jpg"
    ],
    category: "Submachine Guns, British, Korea, Battle Tested, Urban Combat",
    likes: 8
  },
  {
    id: "sten_mk_iii",
    title: "Sten Mk III",
    price: "49",
    description: `The Sten Mk III was the second most produced mark after the Mark II. With its simple design, the Mark III was quicker and cheaper to build than the Mk II. The main difference between the two being the unification of the receiver, ejection port, and barrel shroud which extended farther up the barrel.`,
    images: [
      "/img/guns/_submachine/sten_mkiii/sten_mkiii.jpg",
      "/img/guns/_submachine/sten_mkiii/sten_blurry.jpg"
    ],
    category: "Submachine Guns, Battle Tested, Urban Combat, Top Rated",
    likes: 67
  },
  {
    id: "luger",
    title: "Luger",
    price: "35",
    description: `The Pistole Parabellum, commonly known as just Luger, is a toggle-locked, recoil-operated pistol. It was produced in several models and by several nations from 1898 to 1948. First patented by Georg Luger, it was well known for its wide use by Germany during WWI and WWII, with it being commonly seen throughout pop culture.`,
    images: [
      "/img/guns/_pistols/luger/luger.jpg",
      "/img/guns/_pistols/luger/luger_military.jpg",
      "/img/guns/_pistols/luger/luger_cutaway.jpeg"
    ],
    category: "Pistols, Parabellum, German Engineering, Collector's Item, Movie Famous",
    likes: 5
  },
  {
    id: "mp_40",
    title: "MP 40",
    price: "49",
    description: `The MP 40 is a submachine gun developed by Nazi Germany in 1940. Chambered for the 9x19mm Parabellum cartridge, it was widely used by the Axis powers during WWII. Overall reliable, the MP 40 was used for several decades after WWII by countries around the world.`,
    images: [
      "/img/guns/_submachine/mp40/mp40.jpg",
      "/img/guns/_submachine/mp40/soldier_mp40_use.jpg",
      "/img/guns/_submachine/mp40/soldier_mp40.jpg"
    ],
    category: "Submachine Guns, Parabellum, German Engineering, Battle Tested, Movie Famous, Top Rated",
    likes: 18
  },
  {
    id: "m2_carbine",
    title: "M2 Carbine",
    price: "49",
    description: `The M2 carbine is a version of the M1 carbine, a lightweight .30 caliber submachine gun developed in the 1940s. The M2 carbine is a selective fire version of the M1 carbine. It is capable of firing in semi-automatic or fully automatic modes through a selector switch. The selective fire feature of the M2 carbine is the only significant difference between the M1 and M2.`,
    images: [
      "/img/guns/_submachine/m2_carbine/m2_carbine.jpg",
      "/img/guns/_submachine/m2_carbine/USMC_M1_Carbine.jpg",
      "/img/guns/_submachine/m2_carbine/First_Iwo_Jima_Flag_Raising.jpg"
    ],
    category: "Submachine Guns, Battle Tested",
    likes: 5
  },
  {
    id: "mp5",
    title: "MP5",
    price: "49",
    description: `The MP5 is a 9x19mm Parabellum submachine gun developed by German engineers in the 1960's and manufactured by H&K. Part of its popularity came with its reliability and maneuverability. Lightweight and air-cooled, the MP5 fires from a closed bolt position. Since its production it has been adopted by a variety of military, law enforcement, and security organizations making it one of the most widely used submachine guns in the world.`,
    images: [
      "/img/guns/_submachine/mp5/mp5.jpg",
      "/img/guns/_submachine/mp5/mp5_suppressed.jpg",
      "/img/guns/_submachine/mp5/mp5_soldiers.jpg",
      "/img/guns/_submachine/mp5/mp5_police.jpg"
    ],
    category: "Submachine Guns, Parabellum, German Engineering, Cold War Era, Movie Famous, Battle Tested, Urban Combat, Suppressed",
    likes: 9
  },
  {
    id: "mp5a3",
    title: "MP5A3",
    price: "49",
    description: `The MP5A3 is a variant of the MP5 that features a retractable metal buttstock and the "SEF" trigger group. The "SEF" trigger group being the German version of safe, semi-auto, and full-auto: sicher - safe, einzelfeuer - single fire, and feuerstoss - burst of fire.`,
    images: [
      "/img/guns/_submachine/mp5a3/mp5a3.jpg"
    ],
    category: "Submachine Guns, German Engineering, Urban Combat",
    likes: 2
  },
  {
    id: "mp5k",
    title: "MP5K",
    price: "49",
    description: `In 1976 a shortened machine pistol version of the MP5A2 was introduced; the MP5K (K from the German word Kurz meaning "short") was designed for close quarters battle use by clandestine operations and special services. It has a lighter bolt that led to a higher rate of fire than the standard MP5.`,
    images: [
      "/img/guns/_submachine/mp5k/MP5K.jpg",
      "/img/guns/_submachine/mp5k/military_mp5k.jpg",
      "/img/guns/_submachine/mp5k/matrix_mp5k.jpg"
    ],
    category: "Submachine Guns, German Engineering, Urban Combat, Movie Famous",
    likes: 5
  },
  {
    id: "scorpion_evo",
    title: "Scorpion EVO",
    price: "49",
    description: `The Scorpion EVO is a 9mm carbine developed by Ceska zbrojovka Uhersky Brod in the Czech Republic in 2009. The Scorpion EVO is a blowback operated carbine that uses 9x19 Parabellum ammunition. It is made of mostly polymer which makes the Scorpion EVO a light and compact firearm that can be used in tight spaces. Weighing just 6.10 lbs and shooting 1150 rounds per minute, the Scorpion EVO is currently being used by a variety of countries around the world.`,
    images: [
      "/img/guns/_submachine/scorpion_evo/SCORPION.jpg",
      "/img/guns/_submachine/scorpion_evo/scorpion_suppressed.jpg",
      "/img/guns/_submachine/scorpion_evo/wuc51wovi2e31.jpg",
      "/img/guns/_submachine/scorpion_evo/ffsp18cqbih11.jpg"
    ],
    category: "Submachine Guns, Parabellum, Urban Combat, Suppressed",
    likes: 2
  },
  {
    id: "bnt_uswg",
    title: "B&T USW-G",
    price: "49",
    description: `The B&T USW-G is an add-on enhancement for the popular Glock 17 and 19 pistols with standard rails. It easily converts them into the Universal Weapon configuration including a spring loaded folding stock for added stability.`,
    images: [
      "/img/guns/_submachine/bnt_uswg/bnt_uswg.jpg"
    ],
    category: "Submachine Guns, Swiss Precision, Urban Combat",
    likes: 1
  },
  {
    id: "colt_9mm_smg",
    title: "Colt 9mm SMG",
    price: "49",
    description: `The Colt 9mm SMG, also known as Colt Model 635, is a 9x19mm Parabellum submachine gun based on the M16. Manufactured by Colt beginning in 1982, this firearm is closed bolt and blowback operated giving the Colt 9mm SMG more accuracy compared to open bolt weapons such as the Uzi. Almost identical in look to the M16, the Colt SMG uses an M16 style upper receiver and retained M16-style fire controls.`,
    images: [
      "/img/guns/_submachine/colt_9mm/colt_smg_9mm.jpg",
      "/img/guns/_submachine/colt_9mm/military_colt9mmsmg.jpg"
    ],
    category: "Submachine Guns, Parabellum, Urban Combat",
    likes: 5
  },
  {
    id: "m92",
    title: "M92",
    price: "55",
    description: `The M92 is a carbine and modified hybrid of the AKMSU and AKS-74U. Manufactured by Serbian Zastava Arms, it was developed in 1992 for close combat use. It uses the Soviet 7.62x39mm round and is easier to handle while having a higher rate of fire. With a short barrel, the M92 can easily be concealed and more portable making it a favorite with vehicle crews, pilots, and special forces.`,
    images: [
      "/img/guns/_assault/m92/M92.jpg",
      "/img/guns/_assault/m92/m92_desert.jpg",
      "/img/guns/_assault/m92/m92_soldier.jpg"
    ],
    category: "Assault & Battle Rifles, Extreme, Pick 5, Eastern Bloc, Urban Combat",
    likes: 5
  },
  {
    id: "m16a1",
    title: "M16A1",
    price: "55",
    description: `The M16 is a 5.56mm automatic rifle based off of the ArmaLite AR-15. Deployed in 1964 for jungle warfare during the Vietnam War, the M16A1 later replaced the M14 rifle in 1969 as the standard service rifle for the U.S military. Its improvements included a bolt-assist, chrome-plated bore, and a 30-round magazine. While no longer active in the U.S service, it is standard issue in other world armies.`,
    images: [
      "/img/guns/_assault/m16a1/m16_a1.jpg",
      "/img/guns/_assault/m16a1/m16a1_old.jpg",
      "/img/guns/_assault/m16a1/m16a1_sideview.jpg"
    ],
    category: "Assault & Battle Rifles, Vietnam, Pick 5, NATO Standard, Battle Tested, Top Rated",
    likes: 11
  },
  {
    id: "m16a2",
    title: "M16A2",
    price: "55",
    description: `The development of the M16A2 was requested by the U.S Marine Corps as a result of the combat experience the M16A1 had in Vietnam. Modifications made included new rifling, a thicker barrel at the front to prevent overheating with sustained fire, and a new adjustable rear sight. The reliability of the M16A2 allowed it to be widely used with a few still remaining in service throughout the U.S military today.`,
    images: [
      "/img/guns/_assault/m16a2/M16-A2.jpg",
      "/img/guns/_assault/m16a2/m16a2_sideview.jpg",
      "/img/guns/_assault/m16a2/m16a2_tactical.jpg"
    ],
    category: "Assault & Battle Rifles, NATO Standard, Battle Tested",
    likes: 4
  },
  {
    id: "m16a4",
    title: "M16A4",
    price: "55",
    description: `The M16A4 is the fourth generation in the M16 series. This firearm features a muzzle compensator in place of the flash suppressor to manage recoil as well as a heavier and/or a free-floating barrel to increase accuracy. The M16A4 was the standard infantry rifle for the U.S Marine Corps until the M4 carbine replaced it in 2015. It is now used by support and non-infantry Marines.`,
    images: [
      "/img/guns/_assault/m16a4/m16a4.jpg",
      "/img/guns/_assault/m16a4/m16a4_shooting.jpg",
      "/img/guns/_assault/m16a4/m16a4_sideview.jpg"
    ],
    category: "Assault & Battle Rifles, NATO Standard, Battle Tested",
    likes: 10
  },
  {
    id: "m4",
    title: "M4",
    price: "55",
    description: `The M4 is a shorter and lighter variant of the M16A2 assault rifle. Built in 1984, the first models had an upper receiver with an A1 sight and were given a longer 14.5-inch barrel for the bayonet and the M203 grenade launcher. Known to be a very reliable firearm, the M4 has become widely used by the U.S military.`,
    images: [
      "/img/guns/_assault/m4/m4.jpg",
      "/img/guns/_assault/m4/m4_soldier.jpg",
      "/img/guns/_assault/m4/m4_sideview.jpg"
    ],
    category: "Assault & Battle Rifles, Modern Warfare, Pick 5, NATO Standard, Battle Tested, Top Rated, Suppressed",
    likes: 77
  },
  {
    id: "mk18_mod0",
    title: "Mk 18 Mod 0",
    price: "55",
    description: `The Mk 18 Mod 0 is a M4 or M16 with a Close Quarter Battle Receiver (CQBR) instead of the original upper receiver. This allowed for a firearm the size of a submachine gun with the ability of firing a rifle cartridge. The receiver, developed by the U.S Navy, shortens the barrel to 10.3 in (262 mm) making it easier to maneuver in and around vehicles or tight spaces.`,
    images: [
      "/img/guns/_assault/mk18mod0/mk18_mod0.jpg",
      "/img/guns/_assault/mk18mod0/mk18modO_suppressed.jpg",
      "/img/guns/_assault/mk18mod0/mk18_training.jpg",
      "/img/guns/_assault/mk18mod0/mk18_female.jpg"
    ],
    category: "Assault & Battle Rifles, Urban Combat, Suppressed",
    likes: 6
  },
  {
    id: "m14",
    title: "M14",
    price: "55",
    description: `The M14 rifle is an American select-fire battle rifle designed in 1954. Using 7.62x51mm NATO ammunition, the M14 became the standard-issue rifle for the U.S military in 1959, replacing the M1 Garand for the U.S Army. It still remains in limited service and has been in service longer than any other U.S infantry rifle.`,
    images: [
      "/img/guns/_assault/m14/m14.jpg",
      "/img/guns/_assault/m14/m14_soldier.jpg",
      "/img/guns/_assault/m14/JunctionCity1967SupplyDrop.jpg"
    ],
    category: "Assault & Battle Rifles, Vietnam, Pick 5, NATO Standard, Battle Tested",
    likes: 6
  },
  {
    id: "scar",
    title: "SCAR",
    price: "55",
    description: `The FN SCAR is a combat assault rifle developed by Belgian manufacturer FN Herstal for the United States Special Operations Command (SOCOM). The SCAR was developed with two different types of ammunition: The SCAR-L for light chambered in 5.56x45mm NATO and the SCAR-H for heavy chambered in 7.62x51mm NATO. While the SCAR-L was not as popular, the SCAR-H is now in widespread use by the United States where the light weight, accuracy, and stopping power have proved worth on the battlefield.`,
    images: [
      "/img/guns/_assault/scar/SCAR.jpg",
      "/img/guns/_assault/scar/scar_day.jpg",
      "/img/guns/_assault/scar/scar_night.jpg"
    ],
    category: "Assault & Battle Rifles, NATO Standard, Battle Tested",
    likes: 5
  },
  {
    id: "barking_chihuahua",
    title: "Barking Chihuahua",
    price: "55",
    description: `It's black, brown, small, and LOUD. This custom made firearm looks like an M4 carbine, but carries much more bark. With a shortened barrel and buttstock, the Barking Chihuahua will give you all bark and just as much bite.`,
    images: [
      "/img/guns/_assault/barking_chihuahua/barking_chihuahua.jpg",
      "/img/guns/_assault/barking_chihuahua/barking_chihuahua.jpeg",
      "/img/guns/_assault/barking_chihuahua/kirbs.jpg"
    ],
    category: "Assault & Battle Rifles, Extreme, Pick 5, Urban Combat",
    likes: 5
  },
  {
    id: "steyr_aug",
    title: "Steyr Aug",
    price: "55",
    description: `The Steyr Aug is a 5.56x45mm NATO bullpup rifle developed in 1977. It is gas-operated from a closed bolt position and was designed as a modular weapon system. It can be configured into a rifle, a carbine, a sniper rifle, or an open-bolt squad automatic weapon. The quick-change barrel forged in Steyr Austria, gives it increased precision and durability. It was adopted by the Austrian Army in 1978 and later used around the world by other military agencies.`,
    images: [
      "/img/guns/_assault/steyr_aug/steyr_aug.jpg",
      "/img/guns/_assault/steyr_aug/aug_training.jpg",
      "/img/guns/_assault/steyr_aug/steyraug_diehard.jpg"
    ],
    category: "Assault & Battle Rifles, Bullpup Design, NATO Standard, Movie Famous",
    likes: 7
  },
  {
    id: "sig_553",
    title: "SIG 553",
    price: "55",
    description: `The SG 553 is a variant of the SG 550, an assault rifle manufactured by Swiss Arms AG. First developed in the 1970s, the SG 550 was a successor to the Stgw 57 battle rifle. The SG 553 is an improved version of the SG 552. Released in 2008, the recoil spring was now wrapped around the piston rod, resembling the original SG 550, that addressed several reliability issues. Other versions of the SG 553 includes a long barrel version, one chambered for 7.62x39mm fed from an AK family box magazine, or one chambered for .300 AAC Blackout.`,
    images: [
      "/img/guns/_assault/sig_553/sig_553.jpg"
    ],
    category: "Assault & Battle Rifles, Swiss Precision, NATO Standard",
    likes: 0
  },
  {
    id: "heavy_barrel_fal",
    title: "Heavy-Barrel FAL",
    price: "59",
    description: `The FAL (a French acronym for Fusil Automatique Leger or Light Automatic Rifle) is a widely used battle rifle chambered in 7.62x51mm NATO. Manufactured by FN Herstal, the FAL was introduced in 1951 and has since been described as the "Right Arm of the Free World". During the Cold War, the FAL was adopted by many countries with the exception of the U.S. FAL rifles have been manufactured in both light and heavy-barrel configurations, with the heavy barrel intended for automatic fire as a section or squad light support weapon and majority are equipped with bipods. The FAL is one of the most widely used rifles in history, having been used in more than 90 countries.`,
    images: [
      "/img/guns/_light/heavy_barrel_fal/heavy_barrel_fal.jpg"
    ],
    category: "Light Machine Guns, NATO Standard, Cold War Era, Battle Tested",
    likes: 0
  },
  {
    id: "m1_garand",
    title: "M1 Garand",
    price: "40",
    description: `The M1 Garand is an American .30-.06 caliber semi-automatic rifle. It was the standard U.S service rifle throughout WWII and the Korean War, even having limited time in the Vietnam War. Today it is used by the military in some drills and military honor guards and civilians use it for hunting and as well as a military collectible.`,
    images: [
      "/img/guns/_semi/m1_garand/m1_garand.jpg",
      "/img/guns/_semi/m1_garand/soldier_garand.jpg",
      "/img/guns/_semi/m1_garand/poster_garand.jpg"
    ],
    category: "Semi-Auto, Korea, Beginner, Battle Tested, Collector's Item, Top Rated",
    likes: 14
  },
  {
    id: "barrett_50_cal",
    title: "Barrett 50 cal.",
    price: "40",
    description: `Our M82AI, is a recoil-operated, semi-automatic anti-materiel rifle developed by the American Barrett Firearms Manufacturing company. A heavy SASR (Special Application Scoped Rifle), it is used by many units and armies around the world. It is also called the "Light Fifty" for its .50 BMG (12.7×99mm NATO) chambering.`,
    images: [
      "/img/guns/_semi/barrett/barrett_50_cal.jpg",
      "/img/guns/_semi/barrett/barrett_movie.jpg",
      "/img/guns/_semi/barrett/barrett_bw.jpg"
    ],
    category: "Semi-Auto, Modern Warfare, Extreme, Marksman, Movie Famous, NATO Standard, Top Rated",
    likes: 109
  },
  {
    id: "benelli_m1014",
    title: "Benelli M1014",
    price: "40",
    description: `The Benelli M4 Super 90 is a semi-automatic shotgun made by the Italian firearms manufacturer Benelli Armi SpA. It is the first gas-operated shotgun made by Benelli as the function is designed around a new method: the "auto regulating gas operated" (ARGO) system. Along with this, it is self-regulating for using cartridges of different lengths and power levels. The M1014 is an M4, but carries a different name to signify military usage only.`,
    images: [
      "/img/guns/_semi/benelli/benelli_m1014.jpg",
      "/img/guns/_semi/benelli/USMC-05459.jpg",
      "/img/guns/_semi/benelli/benelli_military.jpg"
    ],
    category: "Semi-Auto, Modern Warfare, Pick 5, Battle Tested, Top Rated",
    likes: 11
  },
  {
    id: "sks",
    title: "SKS",
    price: "40",
    description: `The SKS is a semi-automatic carbine designed by Sergei Gavrilovich Simonov in 1943. Chambered for 7.62x39mm round, the SKS was extremely reliable and simple in design. It had two distinguishing characteristics: one is a permanently attached folding bayonet, the second being a non-detachable magazine. Incapable of fully automatic fire and limited by its ten round magazine capacity, it was later replaced by the AK-47 that was introduced in the 1950s.`,
    images: [
      "/img/guns/_semi/sks/SKS.jpg",
      "/img/guns/_semi/sks/soldier_sks.jpg",
      "/img/guns/_semi/sks/sks_madmax.jpg"
    ],
    category: "Semi-Auto, Vietnam, Pick 5, Beginner, Eastern Bloc, Battle Tested, Cold War Era",
    likes: 3
  },
  {
    id: "psl",
    title: "PSL",
    price: "40",
    description: `The PSL is a marksman rifle also called PSL-54C, Romak III FPK, and SSG-97. Developed in Romania in 1974, the primary purpose of the PSL was to be used by platoon marksmen for targets that were beyond the range of the standard AKM assault rifle. Its operation is similar to the Kalashnikov family of weapons with the same long stroke piston action. Using 7.62x54mmR, the PSL has a ten-round detachable box magazine. Other features include the skeleton stock and an angled cheek riser on the comb of the stock which benefits a right-handed shooter.`,
    images: [
      "/img/guns/_semi/psl/PSL.jpg",
      "/img/guns/_semi/psl/PSL_on_range.jpg",
      "/img/guns/_semi/psl/US_Soldier_demonstrates_the_use_of_a_Dragunov_sniper_rifle_DF-ST-85-13195.jpg"
    ],
    category: "Semi-Auto, Eastern Bloc, Marksman, Battle Tested, Cold War Era",
    likes: 2
  },
  {
    id: "mosin_nagant",
    title: "Mosin Nagant",
    price: "40",
    description: `The Mosin Nagant, or 3-line rifle M1891, is a Russian military rifle developed from 1882 to 1891. A five-shot, bolt-action, internal magazine-fed rifle, the Mosin-Nagant was the most mass-produced military bolt-action rifle in history. With over 37 million units made since 1891, it is still used in various conflicts today despite being over 100 years old.`,
    images: [
      "/img/guns/_bolt/mosin_nagant/mosin_nagant.jpg",
      "/img/guns/_bolt/mosin_nagant/mosin_sniper.jpg",
      "/img/guns/_bolt/mosin_nagant/mosin_soldiers.jpg"
    ],
    category: "Bolt Action, WWII, Pick 5, Beginner, Eastern Bloc, Battle Tested, Collector's Item, Marksman",
    likes: 8
  },
  {
    id: "mosin_nagant_m44",
    title: "Mosin Nagant M44",
    price: "40",
    description: `The Mosin Nagant M44 is a carbine version of the Mosin Nagant, developed for urban combat in World War II. Introduced in late 1944, it also featured a permanently affixed, side-folding bayonet. The M44 was issued to infantry troops as a replacement for the standard rifle.`,
    images: [
      "/img/guns/_bolt/mosin_nagant_m44/mosin_nagant_m44.jpg"
    ],
    category: "Bolt Action, Eastern Bloc, Urban Combat, Battle Tested",
    likes: 1
  },
  {
    id: "de_lisle",
    title: "De Lisle",
    price: "40",
    description: `The De Lisle carbine was a British firearm used during World War II that was designed with an integrated suppressor. That combined with its use of subsonic ammunition, made it extremely quiet in action, possibly one of the quietest firearms ever made. Few were manufactured as their use was limited to specialist military units. Designed by an Air Ministry engineer, William Godfray de Lisle, the primary feature was its extremely effective suppressor, which made it very quiet in action. So quiet that working the bolt, makes a louder noise than firing the cartridge. The suppressor, taking up half of the overall length, provided a large volume to contain the gasses produced by firing, which was key to its effectiveness. However, while the carbine was silent, it was not very accurate. Chambered in .45 ACP, the cartridge was selected due to its muzzle velocity being subsonic for typical barrel lengths.`,
    images: [
      "/img/guns/_bolt/de_lisle/de_lisle.jpg"
    ],
    category: "Bolt Action, British, Collector's Item, Urban Combat",
    likes: 3
  },
];
